import { all, fork } from 'redux-saga/effects';

import { accessManagementSaga } from 'saga/accessManagement/ducks';
import { aclSaga } from 'saga/acl/exports';
import { addressSearchSaga } from 'saga/addressSearch/ducks';
import { adobeAnalyticsSaga } from 'saga/adobeAnalytics/ducks';
import { appInitSaga, appRouteChangedSaga } from 'saga/appHandlers/ducks';
import { authSaga } from 'saga/auth/ducks';
import { backlinkSaga } from 'saga/backlink/ducks';
import { billingDetailSaga } from 'saga/billing/detail/ducks';
import { billingSaga } from 'saga/billing/ducks';
import { installmentSaga } from 'saga/billing/installments/ducks';
import { invoiceToPaySaga } from 'saga/billing/invoicesToPay/ducks';
import { onlinePaymentSaga } from 'saga/billing/onlinePayment/ducks';
import { notifyEventPaymentPaymentInfoSaga } from 'saga/billing/paymentInfo/ducks';
import { paymentsOverviewSaga } from 'saga/billing/paymentsOverview/ducks';
import { allInvoicesSaga } from 'saga/billingManagement/allInvoices/ducks';
import { claimsSaga } from 'saga/billingManagement/claims/ducks';
import { claimStep1Saga } from 'saga/billingManagement/claims/step1/ducks';
import { claimStep2Saga } from 'saga/billingManagement/claims/step2/ducks';
import { claimStep3Saga } from 'saga/billingManagement/claims/step3/ducks';
import { claimStep4Saga } from 'saga/billingManagement/claims/step4/ducks';
import { claimStep5Saga } from 'saga/billingManagement/claims/step5/ducks';
import { claimStep6Saga } from 'saga/billingManagement/claims/step6/ducks';
import { claimStep7Saga } from 'saga/billingManagement/claims/step7/ducks';
import { detailListViewSaga } from 'saga/billingManagement/detailListView/ducks';
import { detailRecordViewSaga } from 'saga/billingManagement/detailRecordView/ducks';
import { downloadDoDocumentSaga } from 'saga/billingManagement/downloadDoDocument/ducks';
import { downloadEBillDocumentSaga } from 'saga/billingManagement/downloadEbillDocument/ducks';
import { invoiceDetailSaga } from 'saga/billingManagement/invoiceDetail/ducks';
import { summaryViewSaga } from 'saga/billingManagement/summaryView/ducks';
import { taxViewSaga } from 'saga/billingManagement/taxView/ducks';
import { codebookSaga } from 'saga/codebook/ducks';
import { contextMainSaga } from 'saga/context';
import { crmDeeplinkSaga } from 'saga/crm-deeplinks/ducks';
import { customerAccountSaga } from 'saga/customerAccount/ducks';
import { customerDetailSaga } from 'saga/customerDetail/ducks';
import { customerRequestsSaga } from 'saga/customerRequests/ducks';
import { documentSaga } from 'saga/document/ducks';
import { filteredDocumentsSaga } from 'saga/filteredDocuments/ducks';
import { journalingSaga } from 'saga/journaling/ducks';
import { kahlSaga } from 'saga/kahl/ducks';
import { localStoreDocumentSaga } from 'saga/localStoreDocument/ducks';
import { OTPSaga } from 'saga/OTP/ducks';
import { documentConsignmentSaga } from 'saga/sendingCreation/ducks';
import { sharedObjectsSaga } from 'saga/sharedObjects/ducks';
import { translationSaga } from 'saga/translation/ducks';

export default function* rootSaga() {
  yield all([
    fork(accessManagementSaga),
    fork(authSaga),
    fork(sharedObjectsSaga),
    fork(journalingSaga),
    fork(contextMainSaga),
    fork(documentSaga),
    fork(documentConsignmentSaga),
    fork(filteredDocumentsSaga),
    fork(kahlSaga),
    fork(codebookSaga),
    fork(localStoreDocumentSaga),
    fork(crmDeeplinkSaga),
    fork(aclSaga),
    fork(adobeAnalyticsSaga),
    fork(appInitSaga),
    fork(appRouteChangedSaga),
    fork(addressSearchSaga),
    fork(customerDetailSaga),
    fork(customerAccountSaga),
    fork(customerRequestsSaga),
    fork(translationSaga),
    fork(detailListViewSaga),
    fork(billingDetailSaga),
    fork(billingSaga),
    fork(installmentSaga),
    fork(taxViewSaga),
    fork(invoiceDetailSaga),
    fork(downloadEBillDocumentSaga),
    fork(downloadDoDocumentSaga),
    fork(claimsSaga),
    fork(claimStep1Saga),
    fork(claimStep2Saga),
    fork(claimStep3Saga),
    fork(claimStep4Saga),
    fork(claimStep5Saga),
    fork(claimStep6Saga),
    fork(claimStep7Saga),
    fork(OTPSaga),
    fork(onlinePaymentSaga),
    fork(detailRecordViewSaga),
    fork(summaryViewSaga),
    fork(paymentsOverviewSaga),
    fork(notifyEventPaymentPaymentInfoSaga),
    fork(allInvoicesSaga),
    fork(backlinkSaga),
    fork(invoiceToPaySaga),
  ]);
}
